<template>
  <div class="template-wrapper">
    <h2 class="page-title">{{ $t('fpsSettlementRecord') }}</h2>
    <el-divider></el-divider>
    <template v-if="exportcsv === '1'">
      <export-excel :data="tableDataExcel" :fields="tableDataExcelFields" name="FPS結算記錄.xls"
        class="el-button el-button--default">
        {{ $t('exportFpsSettlementRecords') }}
      </export-excel>
    </template>

    <template v-if="store_management === '1'">
        <br />
        <br />
        <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
            <template>
            <div class="" style="display: flex">
                <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                    :value="item.storeid"></el-option>
                </el-select>
            </div>
            </template>
        </el-form-item>
        </el-form>
    </template>
    
    <template v-if="store_management === '1'">
        <el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        " stripe style="width: 100%" @sort-change="sortChange">

        <el-table-column prop="txn_settlement_dt" :label="$t('settlementDate')" sortable="custom">
            <template slot-scope="scope">
            <div>{{ scope.row.txn_settlement_dt }} </div>
            </template>
        </el-table-column>
        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="settlementid" :label="$t('settlementid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="settlement_amount_paid" :label="$t('settlementAmount')" sortable="custom">
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" sortable="custom">
            <template slot-scope="scope">
            <div v-if="scope.row.status === 'ACTC'">{{ $t('success') }}</div>
            <div v-if="scope.row.status === 'RJCT'">{{ $t('fail') }}</div>
            <div v-if="scope.row.status === 'pending'">pending</div>
            <div v-if="scope.row.status === 'PDNG'">{{ $t('pendingSettlement') }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="txn_ref_id" :label="$t('transactionid')" sortable="custom">
        </el-table-column>

        <el-table-column prop="operation" :label="$t('adminset')" align="center">
            <template slot-scope="scope">
            <div class="operationVid">
                <el-button @click="viewitem(scope.row)">{{ $t('viewSettlementDetails') }}</el-button>
            </div>
            </template>
        </el-table-column>
        </el-table>
        <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{ tableData.length }} {{ $t('items') }}</span>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="prev,pager,next" :total="tableData.length"></el-pagination>
        </div>
    </template>
    <template v-if="store_management === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>

    <!-- view -->
    <el-dialog :title="viewSettlementTitle" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '856px'"
      :before-close="handleClose" class="view-dialog">
      <h4>{{ $t('settlementAmount') }}: {{ viewSettlementAmount }}</h4>
      <h4>{{ $t('settlementFee') }}: {{ viewSettlementFee }}<span v-if="viewAmount < 500"> + 5.0 ({{ $t('transaction<500')
            }})</span><span v-if="viewAmount >= 500">{{ $t('exemption') }}</span></h4>
      <h4 v-if="viewSettlementStatus === 'ACTC'">{{ $t('status') }}: {{ $t('success') }}</h4>
      <h4 v-if="viewSettlementStatus === 'RJCT'">{{ $t('status') }}: {{ $t('fail') }}</h4>
      <h4 v-if="viewSettlementStatus === 'pending'">{{ $t('status') }}: pending</h4>
      <h4 v-if="viewSettlementStatus === 'PDNG'">{{ $t('status') }}: {{ $t('pendingSettlement') }}</h4>
      <h4 v-if="viewSettlementStatus === 'ACTC'">{{ $t("settlementDate") }}: {{ viewSettlementDate }}</h4>
      <h4 v-if="viewSettlementStatus === 'ACTC'">{{ $t('transactionRange') }}: {{ viewSettlementRangeStart }} -
        {{ viewSettlementRangeEnd }}</h4>
      <h4>{{ $t('transactionAmount') }}: {{ viewAmount }}</h4>
      <el-table :data="viewData.settlements.slice((currentSettlementPage - 1) * pageSettlementSize, currentSettlementPage * pageSettlementSize)
        " stripe style="width: 100%">
        <el-table-column prop="orderid" :label="$t('orderid')" min-width="24%">
        </el-table-column>

        <el-table-column prop="paymentid" :label="$t('paymentid')" min-width="24%">
        </el-table-column>
        <el-table-column prop="amount" :label="$t('transactionAmount')" min-width="15%">
        </el-table-column>
        <el-table-column prop="fee" :label="$t('fee')" min-width="15%">
          <template slot-scope="scope">
            <div>{{ scope.row.fee }} ({{ scope.row.fee_rate }}%)</div>
          </template>
        </el-table-column>
        <el-table-column prop="settlement_amount" :label="$t('settlementAmount')" min-width="15%">
        </el-table-column>


      </el-table>

      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{ viewData.settlements.length }} {{ $t('items') }}</span>
        <el-pagination background @current-change="handleCurrentSettlementChange" :current-page="currentSettlementPage"
          :page-size="pageSettlementSize" layout="prev,pager,next" :total="viewData.settlements.length"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("Sure")
          }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import { getShopOrder, getStore, getFPSHistory } from '@/api'
export default {
  data() {
    return {
        store_management: '0',
      exportcsv: '0',
      show: false,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      currentViewPage: 1, // 当前页码
      pageViewSize: 10, // 每页显示的行数
      dialogVisible: false,
      currentSettlementPage: 1, // 当前页码
      pageSettlementSize: 10,
      tableData: [

      ],
      tableDataExcel: [],
      tableDataExcelFields: {
        'settlement date': 'txn_settlement_dt',
        'store id': 'storeid',
        'settlement id': 'settlementid',
        'settlement amount': 'settlement_amount_paid',
        'status': 'status',
        'txn ref id': 'txn_ref_id',
        'settlements': 'settlements',
      },
      viewData: {
        id: "",
        settlements: []
      },
      viewSettlementTitle: "",
      viewSettlementStatus: "",
      viewSettlementAmount: "",
      viewSettlementDate: "",
      viewSettlementRangeStart: "",
      viewSettlementRangeEnd: "",
      viewSettlementFee: "",
      viewAmount: "",
      qyid: '',
      storeid: '',
      storelist: [],
      storeform: {
        storeid: ''
      },
    }
  },
  filters: {
    formatDate: function (time) {
      time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    var user = JSON.parse(window.localStorage.getItem("userinfo"));
    //console.log(user)
    //this.qyid = user.id

    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
    this.qyid = auser.qyid
    this.storeid = auser.storeid
    if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
    this.store_management = auser.store_management
    this.exportcsv = auser.exportcsv

    this.getlist(auser.storeid);
    this.getstorelist()
  },
  methods: {
    handleCurrentSettlementChange(val) {
      this.currentSettlementPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changeTableStoreid() {
      console.log('storeid:' + this.storeform.storeid)
      this.getlist(this.storeform.storeid)
    },
    getstorelist() {
      console.log('go taocan');
      var user = JSON.parse(window.localStorage.getItem('userinfo'))

      let fdata = {
        qyid: this.qyid,
          storeid: this.storeid
      };
      getStore(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.storelist = res.data
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    getlist(storeid) {
      this.show = true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
        //qyid: user.id,
        qyid: this.qyid,
        storeid: storeid
      };
      getFPSHistory(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
          this.tableDataExcel = res.dataExcel;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.show = false
      });
    },
    viewitem(row) {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      let fdata = {
        //qyid: user.id,
        qyid: this.qyid,
        id: row.id,
        settlementid: row.settlementid,
        action: "viewsettlement"
      };
      console.log('view: ' + row.id + " qyid: " + user.id + " settlementid: " + row.settlementid)
      getFPSHistory(fdata).then((res) => {
        if (res.code == 1) {
          console.log('FPSHistory');
          console.log(res);
          this.viewSettlementTitle = `${this.$t('viewSettlementDetails')}: ${row.settlementid}`;
          this.viewSettlementStatus = row.status;
          this.viewSettlementAmount = row.settlement_amount_paid;
          this.viewSettlementDate = row.txn_settlement_dt;
          this.viewSettlementRangeStart = row.settlement_start;
          this.viewSettlementRangeEnd = row.settlement_end;
          this.viewAmount = row.amount;
          this.viewData.id = row.id;
          this.viewData.settlements = res.data;
          let sum = parseFloat(0.0);
          res.data.forEach(item => {
            sum += parseFloat(item.fee);
          });
          this.viewSettlementFee = parseFloat(sum).toFixed(2);
          console.log('res.data')
          console.log(res.data)
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }



        this.dialogVisible = true;
      });
    },
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop, order));
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.view-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
}

.el-pagination__total {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

.pendingList-wrapper {}

.pagination {
  width: 100%;
  margin: 30px auto;
}

::v-deep .el-select {
  width: 100%;
}
</style>